<template>
  <div class="details" v-bind:class="{
    classPopup: showPopup
  }" v-if="showVideo">
    <section class="movie-detail-container d-flex flex-column " :style="{
      'background-image': 'url(' + currentVideo.coverart.source + ')',
      'max-width': '100%',
    }">
      <HomeNav />
      <div class="mt-auto text-box flex-shrink-0">
        <div class="container-fluid">
          <div class="row justify-content-end">
            <div class="col-md-12 col-lg-5 col-xl-5">
              <h1 class="mt-5 text-white movie-heading">
                {{ currentVideoName }}
              </h1>
              <div class="row text-white py-lg-2  py-md-2  mx-md-0 font-size">
                <div class="col-auto pr-5">
                  {{ currentVideo.metaData["running_time"] }}
                  <div class="pt-4">
                    {{ currentVideoYearOfRelease }}
                  </div>
                </div>
                <div class="col-auto pr-5">
                  {{ currentVideoLanguage }}
                  <div class="pt-4" v-if="showRating">
                    <span class="border  border-box">{{
                      currentVideoMaturityRating
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row text-white pb-lg-3 mx-md-0 py-3">
                <div class="col-auto pr-lg-5 pr-md-3">
                  <a @click="voteVideo(currentVideo, true)" class="border circle">
                    <img src="../assets/img/like.svg" alt="" />
                  </a>
                </div>
                <div class="col-auto  pr-lg-5 pr-md-3">
                  <a @click="voteVideo(currentVideo, false)" class="border circle">
                    <img class="unlike1" src="../assets/img/unlike.svg" alt="" />
                  </a>
                </div>
                <div class="col pr-4 font-size">
                  <p class="text-right py-2 font1">{{ trendingText }}</p>
                </div>
              </div>
              <p class="text-white font-size">
                {{ currentVideoDescription }}
              </p>
              <p class="text-white font1 py-md-1 py-lg-3 font-size">
                Starring:
                <span>{{ currentVideoStarring }}</span>
              </p>
              <p class="top-banner-btn-wrapper">
                <a class="btn btn-lg btn-outline-light" @click="playvideo"
                  v-if="!shouldShowResumeButton(currentVideo)">Watch Now</a>
                <a @click="getresumeHref(currentVideo)" class="btn btn-lg btn-outline-light ml-lg-2"
                  v-if="shouldShowResumeButton(currentVideo)">Resume</a>
                <a @click="handleFav" class="btn btn-lg btn-light ml-md-0 ml-lg-2"><img class="icon1"
                    src="../assets/img/minus-green.svg" v-if="my_favourite(currentVideo)" /><img class="icon1"
                    src="../assets/img/plus-green.svg" v-else />
                  {{ FavTitle }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-auto">
        <div class="container">
          <ul class="nav custom-tabs" id="pills-tab" role="tablist">
            <li class="nav-item mr-5">
              <a class="nav-link active" data-toggle="pill" href="#morelink" role="tab" aria-selected="true">MORE LIKE
                THIS</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="pill" href="#movie-detail" role="tab" aria-selected="false">DETAILS</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="detail-block tab-content" id="pills-tabContent">
      <div class="container-fluid tab-pane fade show active" id="morelink">
        <div class="d-flex flex-wrap justify-content-center">
          <div class="col-desktop" v-for="(card, index) in category_data" :key="index">
            <div class="series-block withhover" @click="goToPlayer(card)">
              <img class="img-fluid" :src="card.thumbnail.large" alt="" />
              <div class="more-cnt text-center">
                <h5 class="pt-md-1 pt-lg-3">{{ getName(card) }}</h5>
                <p class="py-md-1 py-lg-2">{{ currentVideoRunningTime }}</p>
                <p>{{ currentVideoMaturityRating }}</p>
                <p class="py-md-1 py-lg-3">
                  {{ getDescription(card) }}
                </p>
                <div class=" d-flex justify-content-between">
                  <a class="border circle-Sm" @click="voteVideo(card, true)">
                    <img class="like" src="../assets/img/like.svg" alt="" />
                  </a>
                  <a class="border circle-Sm" @click="voteVideo(card, false)">
                    <img class="unlike" src="../assets/img/unlike.svg" alt="" />
                  </a>

                  <a class="border circle-Sm" @click="toggleFavorited(card)">
                    <img class="carouselIcon plus-icon" src="../assets/img/minis-icon.svg" v-if="my_favourite(card)"
                      alt="" />
                    <img class="plus-icon" src="../assets/img/plus.svg" v-else />
                  </a>
                </div>
                <div class="py-md-1 py-lg-3 d-flex justify-content-center">
                  <a @click="playvideo(item)" class="d-inline-block">
                    <img src="../assets/img/play.svg" class="play" alt="" />
                  </a>
                </div>
                <div class="pt-sm-1 pt-lg-2 d-flex justify-content-center">
                  <a @click="gotoDetails(card)" class="d-inline-block btn btn-outline-light">More
                    <i class="fa fa-angle-right ml-2" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container tab-pane fade" id="movie-detail">
        <div class="row detail-link">
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Producer</h6>
              <p>
                {{ currentVideoProducer }}
              </p>
            </div>
            <div class="mb-5">
              <h6 class="mb-3">
                Cast
              </h6>
              <p v-for="(cast, index) in currentVideoCast" :key="index">
                {{ cast }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Writers</h6>
              <p v-for="(Writer, index) in currentVideoWriters" :key="index">
                {{ Writer }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Genres</h6>
              <p v-for="(Genre, index) in currentVideoGenres" :key="index">
                {{ Genre }}
              </p>
            </div>
          </div>
          <div class="col-4 col-md-4 col-lg-3">
            <div class="mb-5">
              <h6 class="mb-3">Maturity Rating</h6>
              <p>{{ currentVideoMaturityRating }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HomeNav from "@/components/HomeNav.vue";
import Helpers from "../Mixins/Helpers.js";
export default {
  name: "Details",
  components: {
    HomeNav,
  },
  watch: {
    "$route.params.vid": {
      handler: function (vid) {
        this.reloadPageData();
      },
      deep: true,
      immediate: true,
    },
  },
  mixins: [Helpers],
  computed: {
    searchData() {
      return this.$store.state.search.currenSearchData;
    },
    FavTitle() {
      if (this.my_favourite(this.currentVideo)) {
        return "Remove from List";
      } else {
        return "Add to List";
      }
    },
    showvideo() {
      if ((currentVideo.name = !"")) {
        return "true";
      } else {
        return "false";
      }
    },
    showplay() {
      if (this.$store.state.globalconfigs.enable_play == "false") {
        return false;
      } else {
        return true;
      }
    },
    showPopup() {
      return this.$store.state.showPopup;
    },
    currentVideoName() {
      if (this.currentVideo.name) {
        return this.currentVideo.name;
      }
      return "";
    },
    currentVideoYearOfRelease() {
      if (this.currentVideo.metaData["Year of Release"]) {
        return this.currentVideo.metaData["Year of Release"];
      }
      return "";
    },
    currentVideoLanguage() {
      if (this.currentVideo.language) {
        return this.currentVideo.language;
      }
      return "";
    },

    currentVideoMaturityRating() {
      if (this.currentVideo.metaData["Maturity Rating"]) {
        return this.currentVideo.metaData["Maturity Rating"];
      } else {
        this.showRating = false;
        return "";
      }
    },
    currentVideoDescription() {
      if (this.currentVideo.description) {
        return this.currentVideo.description;
      }
      return "";
    },
    currentVideoStarring() {
      if (this.currentVideo.metaData.Starring) {
        return this.currentVideo.metaData.Starring;
      }
      return "";
    },
    currentVideoRunningTime() {
      if (this.currentVideo.metaData.running_time) {
        return this.currentVideo.metaData.running_time;
      }
      return "";
    },
    categoryDataName() {
      if (this.category_data.name) {
        return this.category_data.name;
      }

      return "";
    },
    categoryDataDescription() {
      if (this.category_data.description) {
        return this.category_data.description;
      }
      return "";
    },
    currentVideoProducer() {
      if (this.currentVideo.metaData.Producer) {
        return this.currentVideo.metaData.Producer;
      }
      return "";
    },
    currentVideoCast() {
      if (this.currentVideo.metaData.Cast) {
        return this.currentVideo.metaData.Cast.split(",");
      }
      return [];
    },
    currentVideoWriters() {
      if (this.currentVideo.metaData.Writers) {
        return this.currentVideo.metaData.Writers.split(",");
      }
      return [];
    },
    currentVideoGenres() {
      if (this.currentVideo.metaData.Genres) {
        return this.currentVideo.metaData.Genres.split(",");
      }
      return [];
    },
    trendingText() {
      if (this.currentVideo.metaData.trending_text) {
        return this.currentVideo.metaData.trending_text;
      }
      return "";
    }
  },
  filters: {
    trimdis: function (value) {
      return value.slice(0, 200) + "...";
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
  data() {
    return {
      category_data: {},
      showVideo: false,
      currentVideo: {},
      currentCat: "",
      options: null,
      showRating: true,
      duidVal: null,
      resume: true
    };
  },
  methods: {
    getresumeHref(video) {
      this.resume = true;
      this.checkSubs();

    },
    getImagehref(card) {
      if (
        this.$store.state.globalconfigs.detail_page_thumbnail_orientation ==
        "landscape"
      ) {
        return card.thumbnail.large;
      } else if (
        this.$store.state.globalconfigs.detail_page_thumbnail_orientation ==
        "landscape"
      ) {
        return card.coverart.large;
      }
    },
    voteVideo(show, status) {
      this.$store
        .dispatch("voteVideo", {
          id: show.id,
          status: status,
        })
        .then(() => { });
    },
    my_favourite(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    toggleFavorited(show) {
      this.$store.commit("refreshMyList", false);
      if (this.my_favourite(show)) {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: false,
            type: show.type,
          })
          .then(() => { });
      } else {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: true,
            type: show.type,
          })
          .then(() => {
            //this.$store.commit("refreshMyList" ,true)
          });
      }
    },
    goToPlayer(video) {
			if (this.isPlatformMobile() == true || this.isPlatformTablet() == true) {
				this.gotoDetails(video);
			}
		},
    gotoDetails(card) {
      var dynamicRoute = "";
      if (card.type == "vod") {
        dynamicRoute = "/details/" + card.id + "/" + this.$route.params.catid;
      } else if (card.type == "Season") {
        //  dynamicRoute = '/playlistdetails/'+current.id;
      }

      this.$router.push("" + dynamicRoute);
    },
    playvideo() {
      this.checkSubs();
      // var dynamicRoute = "/viewvideo/" + this.$route.params.vid;
      //         this.$router.push("" + dynamicRoute);
    },
    handleFav() {
      if (this.my_favourite(this.currentVideo)) {
        this.$store.dispatch("updatemyList", {
          id: this.currentVideo.id,
          value: false,
          type: this.currentVideo.type,
        });
      } else {
        this.$store.dispatch("updatemyList", {
          id: this.currentVideo.id,
          value: true,
          type: this.currentVideo.type,
        });
      }
    },
    checkSubs() {
      this.$store
        .dispatch("getVideoById", this.$route.params.vid)
        .then((res) => {
          this.video_name = res._embedded.collections[0].name;
          this.$store
            .dispatch("getVideoPlaybackURLV2", {
              videoId: this.$route.params.vid,
              deviceId: this.duidVal,
            })
            .then((res) => {
              if (this.resume == true) {
                var dynamicRoute = "/viewvideo/" + this.$route.params.vid + "?resume=true";
                this.$router.push("" + dynamicRoute);
              } else
                var dynamicRoute = "/viewvideo/" + this.$route.params.vid;
              this.$router.push("" + dynamicRoute);
            })
            .catch((err) => {
              if (err.response.data.error.status == "422") {
                // show upgrade screen popup
              }
              if (err.response.data.error.status == "403") {
                this.$store.commit("showPopup", true);
                this.$store.commit("showdefaultFooter", false)
                window.scroll(0, 0);
              }
              if (err.response.data.error.status == "404 ") {
                this.$store.commit("showPopup", true);
                //this.$store.commit("setNotification", "Please try again later ");
                window.scrollTo(0, 0);
              }
              this.$store.commit("setLoader", false);
            });
        });
    },
    reloadPageData() {
      this.$store.commit("setLoader", true);
      this.currentCat = this.$route.params.catid;
      this.$store
        .dispatch("getVideoById", this.$route.params.vid)
        .then((res) => {
          this.currentVideo = res._embedded.collections[0];
          window.scroll(0, 0);
          if (this.$route.params.catid == "search") {
            this.category_data = this.searchData;
            this.showVideo = true;
            this.$store.commit("setLoader", false);
          } else if (this.$route.params.catid == "mylist") {
            this.category_data = this.searchData;
            this.showVideo = true;
            this.$store.commit("setLoader", false);
          } else {
            this.$store
              .dispatch("getCatalougeById", this.$route.params.catid)
              .then((res) => {
                this.category_data = res._embedded.items;
                this.showVideo = true;
                this.$store.commit("setLoader", false);
              });
          }
        });
    },
    shouldShowResumeButton(video) {
      return this.$store.getters.isvideoResume(video.id);
    },
    getName(card) {
      if (card.name) {
        return card.name;
      }
      return "";
    },
    getDescription(card) {
      if (card.description) {
        return card.description;
      }
      return "";
    },
  },
  created() {
    if (this.$store.state.user.logedin == false) {
      this.$store.commit("showPopup", false);
      this.$store.commit("setLoader", false);
      this.$router.push("/login");
      return false;
    }
    this.$store.commit("showdefaultFooter", true);
    this.$store.commit("showPopup", false);
    this.reloadPageData();
  },
};
</script>

<style scoped>
a,
button {
  cursor: pointer;
}

.text-right {
  padding-top: 3%;
}

.font1 {
  font-size: 14.5px;
}

.btn-lg {
  font-size: 14px;
  padding: 12px 30px !important;
}

.border-box {
  padding: 2px 7px;
}

.container-fluid {
  font-size: calc(5px + 0.5vw);
}

.movie-detail-container {
  min-height: 85vh !important;
}

.mt-auto {
  top: -15px;
  position: relative;
  z-index: 1;
}

.series-block .more-cnt .btn-outline-light {
  color: #679f3d !important;
  border-color: #679f3d;
  background-color: #fff;
  padding: 2px 15px;
  box-shadow: 0px 0px 0px 3px white;
}


.classPopup {
  position: fixed;
}

.font-size {
  font-size: 1vw;
}
</style>
